import { render } from "./PercentGraph.vue?vue&type=template&id=1d6c5a4e"
import script from "./PercentGraph.vue?vue&type=script&lang=js"
export * from "./PercentGraph.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__